import React, { useRef, useState } from "react";
import style from "./Adduser.module.css";
import { TbUserEdit } from "react-icons/tb";
import { BsEye, BsPersonAdd } from "react-icons/bs";
import { RiLockPasswordLine } from "react-icons/ri";
import { BiSolidImageAdd } from "react-icons/bi";
import { CgProfile } from "react-icons/cg";
import { createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { arrayUnion, collection, doc, getDocs, setDoc, writeBatch } from "firebase/firestore";
import { auth, storage, db } from "../../firebase/config";
import { v4 as uuid } from "uuid";
const Adduser = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmpassword, setConfirmPassword] = useState("");
  const [displayname, setDisplayname] = useState("client");
  const [rule, setRule] = useState("client");
  const [roomService,setRoomService]=useState(false)
  const [photo, setPhoto] = useState(
    "https://firebasestorage.googleapis.com/v0/b/arch-chat-ec653.appspot.com/o/client.jpg?alt=media&token=2de615ef-95b2-4e61-933d-3572ba0f4fa5"
  );
  const pass = useRef();
  const adduser = async (e) => {
    e.preventDefault();
    const file = e.target[4].files[0];
    if (file !== undefined) {
      try {
        const res = await createUserWithEmailAndPassword(auth, email, password);
        const storageRef = ref(storage, uuid());
        const uploadTask = uploadBytesResumable(storageRef, file);
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            switch (snapshot.state) {
              case "paused":
                break;
              case "running":
                break;
            }
          },
          (error) => {},
          () => {
            getDownloadURL(uploadTask.snapshot.ref).then(
              async (downloadURL) => {
                await updateProfile(res.user, {
                  displayName: displayname,
                  photoURL: downloadURL,
                });
                await setDoc(doc(db, "users", res.user.uid), {
                  displayname,
                  email,
                  photoURL: downloadURL,
                  uid: res.user.uid,
                  rule: rule,
                  callCenter:roomService
                });
              }
            );
          }
        );
        if (rule === "admin") {
          const roomuserCollectionRef = collection(db, "roomuser");
          const roomuserSnapshot = await getDocs(roomuserCollectionRef);
          const batch = writeBatch(db);
    
          roomuserSnapshot.forEach((doc) => {
            const docRef = doc.ref;
            batch.update(docRef, {
              users: arrayUnion({
                un_read_message: 0,
                user_id: res.user.uid
              })
            });
          });
    
          await batch.commit();
        }
      } catch (error) {
        alert(error);
      }
    } else {
      const res = await createUserWithEmailAndPassword(auth, email, password).catch((err)=>{});
      await updateProfile(res?.user, {
        displayName: displayname,
        photoURL: photo,
      });
      await setDoc(doc(db, "users", res.user.uid), {
        displayname,
        email,
        photoURL: photo,
        uid: res.user.uid,
        rule: rule,
        callCenter:roomService
      });
      if (rule === "admin") {
        const roomuserCollectionRef = collection(db, "roomuser");
        const roomuserSnapshot = await getDocs(roomuserCollectionRef);
        const batch = writeBatch(db);
  
        roomuserSnapshot.forEach((doc) => {
          const docRef = doc.ref;
          batch.update(docRef, {
            users: arrayUnion({
              un_read_message: 0,
              user_id: res.user.uid
            })
          });
        });
  
        await batch.commit();
      }
    }
    
    setConfirmPassword("");
    setEmail("");
    setDisplayname("");
    setPassword("");
  };
  const sowpassword = () => {
    if (pass.current.type === "password") {
      pass.current.type = "text";
    } else {
      pass.current.type = "password";
    }
  };
  return (
    <div className={style.addusercontainer}>
      <div className={style.addusernav}>
        <p>اضافة شخص جديد</p>
        <BsPersonAdd size={48} />
      </div>
      <div className={style.title}>
        <p>من فضلك ادخل البيانات التالية حتي تتمكن من اضافة الشخص</p>
      </div>
      <form onSubmit={adduser}>
        <div className={style.input}>
          <TbUserEdit size={25} color="#999" />
          <input
            type="text"
            value={displayname}
            onChange={(e) => setDisplayname(e.target.value)}
            placeholder="اسم الشخص"
          />
        </div>
        <div className={style.input}>
          <CgProfile size={25} color="#999" />
          <input
            type="email"
            required
            placeholder="الايميل"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className={style.input}>
          <RiLockPasswordLine size={25} color="#999" />
          <input
            ref={pass}
            required
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="كلمة المرور"
          />
          <BsEye
            size={25}
            color="#999"
            cursor="pointer"
            onClick={sowpassword}
          />
        </div>
        <div className={style.input}>
          <RiLockPasswordLine size={25} color="#999" />
          <input
            type="password"
            required
            value={confirmpassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="تاكيد كلمة المرور "
          />
        </div>
        <input type="file" style={{ display: "none" }} id="file" />
        <label className={style.avatar} htmlFor="file">
          <BiSolidImageAdd size={50} />
          <span>add avatar</span>
        </label>
        <div className={style.ratiocontainer}>
          <div className={style.ratiocard}>
            <div
              onClick={() => {
                setRule("engineer");
                setPhoto(
                  "https://firebasestorage.googleapis.com/v0/b/arch-chat-ec653.appspot.com/o/engineer.png?alt=media&token=a5fbbb81-b7f2-470e-930d-3a50078fa47e"
                );
              }}
              style={{ backgroundColor: rule === "engineer" ? "#605F5F" : "" }}
              className={style.ratio}></div>
            <p>مهندس</p>
          </div>
          <div className={style.ratiocard}>
            <div
              onClick={() => {
                setRule("client");
              }}
              style={{ backgroundColor: rule === "client" ? "#605F5F" : "" }}
              className={style.ratio}></div>
            <p>عميل</p>
          </div>
          <div className={style.ratiocard}>
            <div
              onClick={() => {
                setRule("supervisor");
                setPhoto(
                  "https://firebasestorage.googleapis.com/v0/b/arch-chat-ec653.appspot.com/o/supervisor.jpg?alt=media&token=7ec478a4-d848-4a42-afb7-7e98615c273b"
                );
              }}
              style={{
                backgroundColor: rule === "supervisor" ? "#605F5F" : "",
              }}
              className={style.ratio}></div>
            <p>مشرف</p>
          </div>
          <div className={style.ratiocard}>
            <div
              onClick={() => {
                setRule("support");
                setPhoto(
                  "https://firebasestorage.googleapis.com/v0/b/arch-chat-ec653.appspot.com/o/support.jpg?alt=media&token=4317a873-b97e-4854-8b1d-75c5f61102f1"
                );
              }}
              style={{ backgroundColor: rule === "support" ? "#605F5F" : "" }}
              className={style.ratio}></div>
            <p>دعم </p>
          </div>
          <div className={style.ratiocard}>
            <div
              onClick={() => {
                setRule("admin");
                setPhoto(
                  "https://firebasestorage.googleapis.com/v0/b/arch-chat-ec653.appspot.com/o/admin.jpg?alt=media&token=5a00a2d3-88b7-4a27-a898-6eed161a4fe7"
                );
              }}
              style={{ backgroundColor: rule === "admin" ? "#605F5F" : "" }}
              className={style.ratio}></div>
            <p>مدير</p>
          </div>
        </div>
        <div className={style.ratiocontainer}>
          <div className={style.ratiocard}>
            <div
              onClick={() => {
                setRoomService(!roomService)
              }}
              style={{ backgroundColor: roomService === true ? "#605F5F" : "" }}
              className={style.ratio}></div>
            <p>خدمه عملاء</p>
          </div>
        </div>
        <button type="submit" className={style.btn}>
          اضافة شخص
        </button>
      </form>
    </div>
  );
};
export default Adduser;
